 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"comprarProduto":"comprarProduto","extrato-de-utilizacao":"extrato-de-utilizacao","fullScreenImg":"fullScreenImg","politicadeprivacidade":"politicadeprivacidade"}[chunkId]||chunkId) + "." + {"chunk-071fbfb7":"9e993aba","chunk-074511aa":"58e8e266","chunk-075cb7c6":"c07f0e69","chunk-0d50afa6":"2c792867","chunk-120d2dbf":"d1caad1e","chunk-139f0da7":"2eb94953","chunk-155c578e":"ea586289","chunk-15c8dc48":"6ab3b80f","chunk-187932ce":"94b30b6d","chunk-1facc870":"6944f921","chunk-20741906":"909df433","chunk-2160e02e":"d3ebf187","chunk-23a1b52e":"9f8ff677","chunk-27213018":"9299e67c","chunk-2d0b7257":"7f409be7","chunk-2d0be333":"06d117ba","chunk-0db6b168":"422c71cd","chunk-1a30a102":"4c8d75e1","chunk-1cbf0680":"4e7645fe","chunk-2da30585":"668bd694","chunk-4b5858b2":"a02a2e6e","chunk-4f32c61c":"d643c3a2","chunk-995a5288":"d8a265be","chunk-cba64d9e":"e1eb9a47","chunk-381534af":"2159133b","chunk-52b45740":"927ffb2e","chunk-6ffb78af":"7d25db7b","chunk-2d0e1a0f":"04b0d096","chunk-2d0e8833":"8b6a9d18","chunk-2d208e4e":"8d20b610","chunk-2d20f926":"eda1c3e2","chunk-2d212bc7":"c180a7dc","chunk-2d214098":"b3ae8f03","chunk-2d216389":"ebf378de","chunk-2d21a5ca":"d542dd6e","chunk-2ebf9852":"c0e01cb5","chunk-33ca0cb8":"23d25a18","chunk-373819cc":"c630c16c","chunk-6c049c5c":"4a24fad4","chunk-3ab7dc38":"400f5534","chunk-3e99d33c":"7a49c4fb","chunk-41b8a97c":"75f5d826","chunk-421c3750":"a3dc1207","chunk-42ece6d8":"8aff823b","chunk-44b7271e":"14d924db","chunk-469cb23a":"b3f5e4a6","chunk-47fd615e":"052d07fb","chunk-4c8caa0b":"aef81875","chunk-473adf74":"52236516","chunk-500e6eee":"ac0e30c3","chunk-5ab81b10":"ce0a0067","chunk-5b54378a":"ca37d295","chunk-5ba55ecb":"eb938c5f","chunk-5dd22365":"f60ad2e0","chunk-5e0fc00b":"4ceb5e69","chunk-5fe5e248":"9c829b89","chunk-63a37174":"2e43b95b","chunk-6c0f238c":"bd5decf1","chunk-6fef6d80":"815dbd1e","chunk-7001bd53":"74a242d6","chunk-71c0c402":"2fe4a43c","chunk-73e81336":"e0c042de","chunk-74b6fb16":"d58ea8a9","chunk-77275cd3":"ceb4197d","chunk-7cb5b5ec":"d7732b3f","chunk-90772f10":"e04a1e39","chunk-91ea86e4":"a7367dc7","chunk-960bd8a2":"3a0a438f","chunk-a0172dda":"74caf1af","chunk-a07504bc":"8e78d151","chunk-a2e6d42c":"508309b4","chunk-af54b0cc":"fe085007","chunk-b61ce958":"efd2ee00","chunk-c5a504c6":"38dff204","chunk-4d694929":"4d90b8be","chunk-cec48176":"fcd533c0","chunk-d28d7088":"2cb72e7b","chunk-d33dfc22":"26af3cc3","chunk-d378dee4":"95e0705e","chunk-d3f578b4":"521dda7c","chunk-d572a910":"35fd514d","chunk-daa727a2":"c212596e","chunk-e8d8a9c8":"06c25856","chunk-ff7671b4":"4c40f8b2","comprarProduto":"9878d901","extrato-de-utilizacao":"3543af6b","fullScreenImg":"ce65a193","politicadeprivacidade":"f1c1049f","chunk-2d0a4885":"4bb8e1c1","chunk-2d0f0050":"09f1b677","chunk-1b84d8f0":"52875a59"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-074511aa":1,"chunk-075cb7c6":1,"chunk-0d50afa6":1,"chunk-120d2dbf":1,"chunk-139f0da7":1,"chunk-155c578e":1,"chunk-15c8dc48":1,"chunk-187932ce":1,"chunk-1facc870":1,"chunk-20741906":1,"chunk-2160e02e":1,"chunk-23a1b52e":1,"chunk-27213018":1,"chunk-0db6b168":1,"chunk-1a30a102":1,"chunk-1cbf0680":1,"chunk-2da30585":1,"chunk-4b5858b2":1,"chunk-995a5288":1,"chunk-381534af":1,"chunk-52b45740":1,"chunk-6ffb78af":1,"chunk-373819cc":1,"chunk-6c049c5c":1,"chunk-3ab7dc38":1,"chunk-3e99d33c":1,"chunk-41b8a97c":1,"chunk-421c3750":1,"chunk-42ece6d8":1,"chunk-44b7271e":1,"chunk-469cb23a":1,"chunk-47fd615e":1,"chunk-4c8caa0b":1,"chunk-473adf74":1,"chunk-500e6eee":1,"chunk-5ab81b10":1,"chunk-5b54378a":1,"chunk-5ba55ecb":1,"chunk-5dd22365":1,"chunk-5e0fc00b":1,"chunk-5fe5e248":1,"chunk-63a37174":1,"chunk-6c0f238c":1,"chunk-6fef6d80":1,"chunk-7001bd53":1,"chunk-71c0c402":1,"chunk-73e81336":1,"chunk-7cb5b5ec":1,"chunk-90772f10":1,"chunk-960bd8a2":1,"chunk-a0172dda":1,"chunk-a07504bc":1,"chunk-a2e6d42c":1,"chunk-af54b0cc":1,"chunk-b61ce958":1,"chunk-4d694929":1,"chunk-cec48176":1,"chunk-d28d7088":1,"chunk-d378dee4":1,"chunk-d3f578b4":1,"chunk-d572a910":1,"chunk-daa727a2":1,"comprarProduto":1,"extrato-de-utilizacao":1,"politicadeprivacidade":1,"chunk-1b84d8f0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"comprarProduto":"comprarProduto","extrato-de-utilizacao":"extrato-de-utilizacao","fullScreenImg":"fullScreenImg","politicadeprivacidade":"politicadeprivacidade"}[chunkId]||chunkId) + "." + {"chunk-071fbfb7":"31d6cfe0","chunk-074511aa":"52059d75","chunk-075cb7c6":"5588f5c9","chunk-0d50afa6":"8b6f1afd","chunk-120d2dbf":"a6642f4e","chunk-139f0da7":"489ff709","chunk-155c578e":"2f7c8374","chunk-15c8dc48":"8d03b27c","chunk-187932ce":"792e29f5","chunk-1facc870":"6d7a725b","chunk-20741906":"fbd2a0bb","chunk-2160e02e":"70e941dd","chunk-23a1b52e":"0ad55781","chunk-27213018":"81c98645","chunk-2d0b7257":"31d6cfe0","chunk-2d0be333":"31d6cfe0","chunk-0db6b168":"8f948fac","chunk-1a30a102":"8437d628","chunk-1cbf0680":"f61b1455","chunk-2da30585":"ab438c15","chunk-4b5858b2":"e3925d85","chunk-4f32c61c":"31d6cfe0","chunk-995a5288":"ab77ccaa","chunk-cba64d9e":"31d6cfe0","chunk-381534af":"7fb0ad9c","chunk-52b45740":"95425ad6","chunk-6ffb78af":"843b07bf","chunk-2d0e1a0f":"31d6cfe0","chunk-2d0e8833":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d20f926":"31d6cfe0","chunk-2d212bc7":"31d6cfe0","chunk-2d214098":"31d6cfe0","chunk-2d216389":"31d6cfe0","chunk-2d21a5ca":"31d6cfe0","chunk-2ebf9852":"31d6cfe0","chunk-33ca0cb8":"31d6cfe0","chunk-373819cc":"cb3ddce0","chunk-6c049c5c":"34b00e1d","chunk-3ab7dc38":"7ed1afb7","chunk-3e99d33c":"1f2b6801","chunk-41b8a97c":"80e66beb","chunk-421c3750":"47427fa4","chunk-42ece6d8":"c298bbb9","chunk-44b7271e":"c1703a88","chunk-469cb23a":"cdc1201f","chunk-47fd615e":"6b019d40","chunk-4c8caa0b":"d572573d","chunk-473adf74":"181d79e4","chunk-500e6eee":"7979a6ca","chunk-5ab81b10":"d5355744","chunk-5b54378a":"2095e8ca","chunk-5ba55ecb":"de822583","chunk-5dd22365":"7244f986","chunk-5e0fc00b":"529ae620","chunk-5fe5e248":"cfb8a241","chunk-63a37174":"1c65af2c","chunk-6c0f238c":"d1d60d0b","chunk-6fef6d80":"bde5b26d","chunk-7001bd53":"d25d490d","chunk-71c0c402":"f9bac9aa","chunk-73e81336":"93c1c233","chunk-74b6fb16":"31d6cfe0","chunk-77275cd3":"31d6cfe0","chunk-7cb5b5ec":"145e4953","chunk-90772f10":"1013e4ce","chunk-91ea86e4":"31d6cfe0","chunk-960bd8a2":"906c9eec","chunk-a0172dda":"377a8dbb","chunk-a07504bc":"a8eb8159","chunk-a2e6d42c":"0261b599","chunk-af54b0cc":"b510c0cf","chunk-b61ce958":"e8e31b9b","chunk-c5a504c6":"31d6cfe0","chunk-4d694929":"02aabb69","chunk-cec48176":"6bee5493","chunk-d28d7088":"6fb8115e","chunk-d33dfc22":"31d6cfe0","chunk-d378dee4":"95737b88","chunk-d3f578b4":"27de3cf1","chunk-d572a910":"a43e69fb","chunk-daa727a2":"a7a48ede","chunk-e8d8a9c8":"31d6cfe0","chunk-ff7671b4":"31d6cfe0","comprarProduto":"9a30e8a5","extrato-de-utilizacao":"364d26ed","fullScreenImg":"31d6cfe0","politicadeprivacidade":"7c8e5808","chunk-2d0a4885":"31d6cfe0","chunk-2d0f0050":"31d6cfe0","chunk-1b84d8f0":"6f5fe4f9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
